// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__9qwbm","slide":"carousel_slide__y4dWk","dots":"carousel_dots__Z0gNE","dot":"carousel_dot__zlDTT","active":"carousel_active__5wAaV"};